import dynamic from 'next/dynamic'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import MeasuringGuideLegacy, { type MeasuringGuideProps } from './MeasuringGuide-legacy'

const MeasuringGuideDS = dynamic(() =>
  import(/* webpackChunkName: "measuring-guide-ds" */ '@src/components/blocks/measuring-guide-ds').then(m => ({
    default: m.MeasuringGuideDS,
  })),
)

const MeasuringGuide = (props: MeasuringGuideProps) => {
  if (shouldUseDesignSystem()) {
    return <MeasuringGuideDS {...props} />
  }
  return <MeasuringGuideLegacy {...props} />
}

export type { MeasuringGuideProps }
export default MeasuringGuide
